import axiosInstance from "../../axiosConfig";
import { TOAST_TYPES_ENUM } from "../../enums";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { Toast } from "../../shared";
import { ChangePasswordTypes } from "../../types/AuthTypes";

export const useChangePassword = (
  options?: UseMutationOptions<any, Error, ChangePasswordTypes>
) => {
  return useMutation({
    mutationKey: ["changePassword"],
    mutationFn: async (credentials: ChangePasswordTypes) => {
      return axiosInstance
        .post(`/change-password`, credentials)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Zmiana hasła...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "changePassword",
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Hasło zostało zmienione pomyślnie",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "changePassword",
      });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      if (error?.status === 500) {
        Toast({
          message: "Błąd serwera",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "changePassword",
        });
      } else if (error?.status === 401) {
        Toast({
          message: "Niepoprawne aktualne hasło",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "changePassword",
        });
      } else {
        Toast({
          message: "Błąd podczas zmiany hasła",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "changePassword",
        });
      }
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
